import React, { useState, useCallback } from 'react';

import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';
import { NumberInput } from 'ui-components/components/number-input';
import { Text, TextType } from 'ui-components/components/text';

import InputValueProps from '../../../../../../prop-types/input-value-props';
import { INT_PARAMETER, PARAMETER } from '../../../../../../constants/parameter-name-for-update';
import { messages } from './messages';

import style from '../style.module.less';
import sharedStyles from '../../../../../../style.module.less';

const DateTypes = {
  OrderDate: 'OrderDate',
  DeliverByDate: 'DeliverByDate',
};

const dateTypeMessageMap = {
  [DateTypes.OrderDate]: <FormattedMessage {...messages.afterOrderDate} />,
  [DateTypes.DeliverByDate]: <FormattedMessage {...messages.beforeDeliverByDate} />,
};

const SetDaysAroundDate = ({ inputValueProps, onChange, hasError, label }) => {
  const { parameter, intParameter } = inputValueProps;
  const [numberOfDays, setNumberOfDays] = useState(intParameter || 0);
  const [selectedDateType, setSelectedDateType] = useState(parameter || DateTypes.OrderDate);

  const onChangeDays = useCallback(
    (newValue) => {
      setNumberOfDays(newValue);
    },
    [setNumberOfDays],
  );

  const onBlurDays = useCallback(() => {
    onChange({
      [INT_PARAMETER]: numberOfDays,
    });
  }, [onChange, numberOfDays]);

  const onArrowButtonPress = useCallback(
    (newValue) => {
      setNumberOfDays(newValue);
      onChange({
        [INT_PARAMETER]: newValue,
      });
    },
    [setNumberOfDays, onChange],
  );

  const onChangeDateType = useCallback(
    (newDateType) => {
      setSelectedDateType(newDateType);
      onChange({
        [PARAMETER]: newDateType,
      });
    },
    [setSelectedDateType, onChange],
  );

  const daysInput = (
    <NumberInput
      className={classnames(style['days-input'], { [style.error]: hasError })}
      onArrowButtonPress={onArrowButtonPress}
      onBlur={onBlurDays}
      onChange={onChangeDays}
      value={numberOfDays}
    />
  );

  const dateTypeDropdown = (
    <DropdownMenu className={style['date-type-dropdown']} dropdownMenuShouldHaveWidthOfButton dropdownMenuType={DropdownMenuType.ComboBox}>
      <DropdownMenuToggler className={sharedStyles['dropdown-toggler']}>{dateTypeMessageMap[selectedDateType]}</DropdownMenuToggler>
      <DropdownMenuItem onClick={() => onChangeDateType(DateTypes.OrderDate)}>{dateTypeMessageMap[DateTypes.OrderDate]}</DropdownMenuItem>
      <DropdownMenuItem onClick={() => onChangeDateType(DateTypes.DeliverByDate)}>
        {dateTypeMessageMap[DateTypes.DeliverByDate]}
      </DropdownMenuItem>
    </DropdownMenu>
  );

  return (
    <div className={style['multi-control-row']}>
      <div>{label}</div>
      <Text
        className={style['set-days-around-date']}
        element='div'
        formattedMessageValues={{
          daysInput: () => daysInput,
          dateTypeDropdown: () => dateTypeDropdown,
        }}
        textType={TextType.Paragraph}
        value={messages.daysAroundDate}
      />
    </div>
  );
};

SetDaysAroundDate.propTypes = {
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  label: PropTypes.node.isRequired,
};

export default SetDaysAroundDate;
